import { createWidgetItem, getWidgetList } from "./requests";

export const findWidgetByName = (name: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        getWidgetList()
            .then((res) => {
                const widgets = res.data || [];
                const widget = widgets.find((w) => w.name === name);
                if (widget) {
                    resolve(widget);
                } else {
                    createWidgetItem({
                        name: name,
                        status: "published",
                        active: true,
                        code: name?.toLowerCase().replace(/ /g, "-"),
                        settings: {},
                        is_deletable: 0,
                    }).then((res) => {
                        resolve(res);
                    });
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};